/** Canales IPC que la UI invoca (espejo del Backend Runtime & IPC Surface, Fase 5). */
export const IPC_CHANNELS = {
  brainOverview: "brain.overview.get",
  brainAiRecommendation: "brain.ai.recommendation",
  engineOverview: "system.engine.overview",
  analyticsTargetsList: "analytics.targets.list",
  analyticsTargetsSet: "analytics.targets.set",
  productDevelopmentOverview: "product_development.overview.get",
  productDevelopmentOpen: "product_development.investigation.open",
  productDevelopmentSimulate: "product_development.investigation.simulate",
  accountsList: "accounts.list",
  accountsAdd: "accounts.add",
  accountsSetActive: "accounts.setActive",
  accountsRename: "accounts.rename",
  accountsRemove: "accounts.remove",
  accountsConsolidated: "accounts.consolidated",
  credentialsStatus: "settings.credentials.status",
  credentialsSave: "settings.credentials.save",
  credentialsTest: "settings.credentials.test",
  mlBeginConnect: "settings.credentials.ml.beginConnect",
  mlCompleteConnect: "settings.credentials.ml.completeConnect",
  onboardingStatus: "settings.onboarding.status",
  onboardingComplete: "settings.onboarding.complete",
  businessConfigGet: "settings.business.get",
  businessConfigSave: "settings.business.save",
  syncConfigGet: "settings.sync.get",
  syncConfigSave: "settings.sync.save",
  marketplaceSyncAll: "marketplace.syncAll",
  exportSave: "system.export.save",
  exportSaveImage: "system.export.saveImage",
  productImagesAnalyze: "product.images.analyze",
  productImagesGenerate: "product.images.generate",
  productDescriptionGenerate: "product.description.generate",
  updateStatus: "system.update.status",
  updateCheck: "system.update.check",
  updateInstall: "system.update.install",
  mlAccount: "integrations.mercadolibre.account",
  aiAsk: "integrations.ai.ask",
  mlDataSpike: "integrations.ml.spike",
  trendCategories: "market.trends.categories",
  trendSubcategories: "market.trends.subcategories",
  trendBestSellers: "market.trends.bestSellers",
  trendAnalyze: "market.trends.analyze",
  trendCapture: "market.trends.capture",
  trendTracked: "market.trends.tracked",
  trendHistory: "market.trends.history",
  trendReviews: "market.trends.reviews",
  trendWatchlist: "market.trends.watchlist",
  trendWatchAdd: "market.trends.watch.add",
  trendWatchRemove: "market.trends.watch.remove",
  trendWatchRun: "market.trends.watch.run",
  mlQuestionsList: "integrations.ml.questions.list",
  mlQuestionsDraft: "integrations.ml.questions.draft",
  mlQuestionAnswer: "integrations.ml.questions.answer",
  backupCreate: "system.backup.create",
  backupList: "system.backup.list",
  backupRestore: "system.backup.restore",
  backupExport: "system.backup.export",
  backupImport: "system.backup.import",
  notificationsList: "system.notifications.list",
  notificationsMarkAllRead: "system.notifications.markAllRead",
  notificationsDismiss: "system.notifications.dismiss",
  notificationsClear: "system.notifications.clear",
  productCreate: "product.create",
  productActivate: "product.activate",
  productDeactivate: "product.deactivate",
  productArchive: "product.archive",
  productCatalog: "product.catalog.list",
  skuInfo: "catalog.sku.info",
  customerCreate: "customer.create",
  customerActivate: "customer.activate",
  customerDeactivate: "customer.deactivate",
  customerArchive: "customer.archive",
  supplierCreate: "supplier.create",
  supplierActivate: "supplier.activate",
  supplierDeactivate: "supplier.deactivate",
  supplierArchive: "supplier.archive",
  supplierBlacklist: "supplier.blacklist",
  salesCreate: "sales.order.create",
  salesConfirm: "sales.order.confirm",
  salesCancel: "sales.order.cancel",
  salesCustomers: "sales.customers.list",
  inventoryCreate: "inventory.item.create",
  inventoryMove: "inventory.item.move",
  purchaseCreate: "purchase.order.create",
  purchaseApprove: "purchase.order.approve",
  purchaseCancel: "purchase.order.cancel",
  purchaseReceive: "purchase.order.receive",
  purchaseSuppliers: "purchase.suppliers.list",
  pricingCreate: "pricing.list.create",
  pricingAddPrice: "pricing.list.addPrice",
  pricingPublish: "pricing.list.publish",
  pricingArchive: "pricing.list.archive",
  logisticsCreate: "logistics.shipment.create",
  logisticsDispatch: "logistics.shipment.dispatch",
  logisticsDeliver: "logistics.shipment.deliver",
  logisticsCancel: "logistics.shipment.cancel",
  marketplaceCreate: "marketplace.publication.create",
  marketplacePublish: "marketplace.publication.publish",
  marketplacePause: "marketplace.publication.pause",
  marketplaceResume: "marketplace.publication.resume",
  marketplaceDelete: "marketplace.publication.delete",
  marketplaceSyncMl: "marketplace.publication.syncMl",
  marketplaceImportOrders: "marketplace.orders.import",
  marketplaceImportListings: "marketplace.listings.import",
  aiRegister: "ai.model.register",
  aiActivate: "ai.model.activate",
  aiRetire: "ai.model.retire",
} as const;

export type IpcChannel = (typeof IPC_CHANNELS)[keyof typeof IPC_CHANNELS];
